var header = (function () {
  
    /* ********** Exponerade funktioner     */
    function initHeader() {
        // On dropdown open
        var loginDropdown = document.getElementById('loginDropdown')
        loginDropdown.addEventListener('show.bs.dropdown', function () {
            
            setTimeout(function() {
                loginDropdown.querySelector('.dropdown-menu li:first-child a').focus();  
            })
        })

        // On dropdown close
        loginDropdown.addEventListener('hidden.bs.dropdown', function () {
            
            setTimeout(function() {
                loginDropdown.querySelector('.dropdown-toggle').focus();  
            })
        })
    }
  
    return {
      initHeader: initHeader,
    };
  })();
  
  export default header;